import {getResource} from './BaseRequests'

export const fetchProduct = ({ productId }, success, fail) => {
    const productIdStr = String(productId)
    getResource("product", {id: productIdStr}, false).then(success).catch(fail)
}

export const fetchRecommendedProducts = ({productId}, success, fail) =>{
    getResource("recommended_products", {id: productId}).then(success).catch(fail)
}

export const stickers = {
	"0": 'none',
	"1": 'new',
	"2": 'special',
	"3": 'none',
	"4": 'sold-out',
	"5": 'hot',
	"6": 'save',
	"7": 'info-product',
	"8": 'discount-partner'
}